import { BrowserRouter, Route, Routes } from "react-router-dom"
import { ProtectedRoutes, ProtectedRoutesLogin } from "./Autorizador"
import ErrorPage from "../page/errorPage/ErrorPage"
import LoginPage from "../page/login/LoginPage"
import HomeAdminPage from "../page/admin/home/HomeAdminPage"
import BannersAdminPage from "../page/admin/banners/BannersAdminPage"
import UsuariosAppPage from "../page/admin/UsuariosApp/UsuariosAppPage"
import AddBannerPage from "../page/admin/banners/AddBannerPage"
import PromocionesPage from "../page/admin/paseoPlus/promociones/PromocionesPage"
import ActivacionesAdminPage from "../page/admin/activaciones/ActivacionesAdminPage"
import AddActivacionesPage from "../page/admin/activaciones/AddActivacionesPage"
import EventosAppPage from "../page/admin/eventos/EventosAppPage"
import PromocionesAppPage from "../page/admin/promociones/PromocionesAppPage"
import LocalesPage from "../page/admin/locales/LocalesPage"
import CategoriasPage from "../page/admin/locales/CategoriasPage"
import BeneficiosPage from "../page/admin/beneficios/BeneficiosPage"
import BeneficiosEspecialesPage from "../page/admin/beneficios/BeneficiosEspecialesPage"
import AddPromocionPage from "../page/admin/paseoPlus/promociones/AddPromocionPage"
import AddEventoPage from "../page/admin/eventos/AddEventoPage"
import UsuariosLocalesPage from "../page/admin/paseoPlus/usuariosParaLocales/UsuariosLocalesPage"
import SorteosAppPage from "../page/admin/sorteos/SorteosAppPage"
import CuponesPage from "../page/admin/cupones/CuponesPage"
import AddUsuarioLocalPage from "../page/admin/paseoPlus/usuariosParaLocales/AddUsuarioLocalPage"
import AddSorteoPage from "../page/admin/sorteos/AddSorteoPage"
import HistorialPage from "../page/admin/atc/HistorialPage"
import ItemsPage from "../page/admin/atc/ItmesPage"
import AddItemPage from "../page/admin/atc/AddItemPage"
import CrearTransaccionPage from "../page/admin/atc/CrearTransaccionPage"
import ObsequiosCategoriasPage from "../page/admin/obsequios/categorias/ObsequiosCategoriasPage"
import AddObsequioCategoriaPage from "../page/admin/obsequios/categorias/AddObsequioCategoriaPage"
import ObsequiosSubCategoriasPage from "../page/admin/obsequios/subCategorias/ObsequiosSubCategoriasPage"
import AddSubCategoriaPage from "../page/admin/obsequios/subCategorias/AddSubCategoriaPage"
import ObsequiosPage from "../page/admin/obsequios/obsequiosInicio/ObsequiosPage"
import AddObsequiosPage from "../page/admin/obsequios/obsequiosInicio/AddObsequiosPage"
import InformeGeneralPage from "../page/admin/obsequios/informeGeneral/InformeGeneralPage"
import EncuestasPage from "../page/admin/encuestas/EncuestasPage"
import AddEncuestaPage from "../page/admin/encuestas/AddEncuestaPage"
import AddLocalPage from "../page/admin/locales/AddLocalPage"
import EditarUsuarioPage from "../page/admin/UsuariosApp/EditarUsuarioPage"
import DetalleCuponPage from "../page/admin/cupones/DetalleCuponPage"
import EditarCuponPage from "../page/admin/cupones/EditarCuponPage"
import BeneficioAddDetailsPage from "../page/admin/beneficios/BeneficioAddDetailsPage"
import BeneficiosLocalesAdheridosPage from "../page/admin/beneficios/BeneficiosLocalesAdheridosPage"
import AdherirLocalPage from "../page/admin/beneficios/AdherirLocalPage"
import FacturasPage from "../page/admin/facturas/FacturasPage"
import FacturasPendientesPage from "../page/admin/facturas/FacturasPendientesPage"
import FacturasDobleCheckPage from "../page/admin/facturas/FacturasDobleCheckPage"
import PromocionAddPage from "../page/admin/promociones/PromocionAddPage"
import PromocionAddImagePage from "../page/admin/promociones/PromocionAddImagePage"
import ValesPage from "../page/admin/paseoPlus/vales/ValesPage"
import CanjesPage from "../page/admin/paseoPlus/canjes/CanjesPage"
import CanjeDetallePage from "../page/admin/paseoPlus/canjes/CanjeDetallePage"
import NotificacionesPage from "../page/admin/notificaciones/NotificacionesPage"
import AddNotificacionPage from "../page/admin/notificaciones/AddNotificacionPage"
import EventoAddEditPage from "../page/admin/eventos/EventoAddEditPage"
import PromocionAddEditPage from "../page/admin/promociones/PromocionAddEditPage"
import AddCategoriaPage from "../page/admin/locales/AddCategoriaPage"
import DetalleUsuarioPage from "../page/admin/UsuariosApp/DetalleUsuarioPage"
import LocalDetallePage from "../page/admin/locales/LocalDetallePage"
import FacturaDetallePage from "../page/admin/facturas/FacturaDetallePage"
import ReportesPage from "../page/admin/giftCard/reportes/ReportesPage"
import EmpresasGiftCardPage from "../page/admin/giftCard/empresas/EmpresasGiftCardPage"
import AddEmpresaGiftCardPage from "../page/admin/giftCard/empresas/AddEmpresaGiftCardPage"
import GiftCardPage from "../page/admin/giftCard/giftCard/GiftCardPage"
import GiftCardDetallePage from "../page/admin/giftCard/giftCard/GiftCardDetallePage"
import ComprasPage from "../page/admin/compras/ComprasPage"
import AddCompraPage from "../page/admin/compras/AddCompraPage"
import ValeAddPage from "../page/admin/paseoPlus/vales/ValeAddPage"
import UsuariosLocalesAdminPage from "../page/admin/UsuariosLocales/UsuariosLocalesAdminPage"
import ResetUsuarioPage from "../page/admin/UsuariosApp/ResetUsuarioPage"
import FiltrarObsequiosPage from "../page/admin/obsequios/filtrarFacturaObsequio/FiltrarObsequiosPage"
import FacturaObsequioDetallePage from "../page/admin/obsequios/filtrarFacturaObsequio/FacturaObsequioDetallePage"
import ListarFacturasObsequiosPage from "../page/admin/obsequios/listarFacturasObsequios/ListarFacturasObsequiosPage"
import BuscarCuponPage from "../page/admin/sorteos/BuscarCuponPage"
import SorteoDetalle from "../page/admin/sorteos/SorteoDetalle"
import SorteadorPage from "../page/admin/sorteos/SorteadorPage"
import CuponDetallePage from "../page/admin/sorteos/CuponDetallePage"


function RutesScreen() {

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedRoutes />} >
          <Route path="/app/admin" element={<HomeAdminPage />} />


          {/*==================== Usuarios ====================*/}
          <Route path="/app/admin/usuarios-locales" element={<UsuariosLocalesAdminPage />} />

          {/*==================== Usuarios ====================*/}
          <Route path="/app/admin/usuarios-app" element={<UsuariosAppPage />} />
          <Route path="/app/admin/usuarios-app/editar/:id" element={<EditarUsuarioPage />} />
          <Route path="/app/admin/usuarios-app/detalle/:id" element={<DetalleUsuarioPage />} />
          <Route path="/app/admin/usuarios-app/detalle-reset/:id" element={<ResetUsuarioPage />} />

          <Route path="/app/admin/activaciones" element={<ActivacionesAdminPage />} />
          <Route path="/app/admin/activaciones-agregar" element={<AddActivacionesPage />} />

          {/*==================== Paseo Plus ====================*/}
          <Route path="/app/admin/paseo-plus-promociones" element={<PromocionesPage />} />
          <Route path="/app/admin/paseo-plus-promociones-agregar" element={<AddPromocionPage />} />
          <Route path="/app/admin/paseo-plus-user-locales" element={<UsuariosLocalesPage />} />
          <Route path="/app/admin/paseo-plus-user-locales-agregar" element={<AddUsuarioLocalPage />} />
          <Route path="/app/admin/paseo-plus-user-locales-editar/:id" element={<AddUsuarioLocalPage />} />

          <Route path="/app/admin/paseo-plus/vales" element={<ValesPage />} />
          <Route path="/app/admin/paseo-plus/vales/agregar" element={<ValeAddPage />} />
          <Route path="/app/admin/paseo-plus/vales/detalle/:id?" element={<ValeAddPage />} />
          <Route path="/app/admin/paseo-plus/vales/editar/:id?" element={<ValeAddPage />} />

          <Route path="/app/admin/paseo-plus/canjes" element={<CanjesPage />} />
          <Route path="/app/admin/paseo-plus/canje/detalle/:id" element={<CanjeDetallePage />} />




          {/*==================== Gift card ====================*/}
          <Route path="/app/admin/paseo-plus/gift-card" element={<GiftCardPage />} />
          <Route path="/app/admin/paseo-plus/gift-card/detalle/:id?" element={<GiftCardDetallePage />} />

          <Route path="/app/admin/paseo-plus/reportes" element={<ReportesPage />} />

          <Route path="/app/admin/paseo-plus/locales" element={<EmpresasGiftCardPage />} />
          <Route path="/app/admin/paseo-plus/add-local/:id?" element={<AddEmpresaGiftCardPage />} />




          {/*==================== Compras ====================*/}
          <Route path="/app/admin/compras" element={<ComprasPage />} />
          <Route path="/app/admin/compras/agregar" element={<AddCompraPage />} />



          {/*==================== Eventos ====================*/}
          <Route path="/app/admin/eventos" element={<EventosAppPage />} />
          <Route path="/app/admin/eventos-agregar" element={<EventoAddEditPage />} />
          <Route path="/app/admin/evento-detalle/:id" element={<EventoAddEditPage />} />


          {/*==================== Promocioens ====================*/}
          <Route path="/app/admin/promociones" element={<PromocionesAppPage />} />
          {/* <Route path="/app/admin/promociones/agregar" element={<PromocionAddPage />} /> */}
          {/* <Route path="/app/admin/promocion/detalle/:id" element={<PromocionAddPage />} /> */}
          <Route path="/app/admin/promociones/agregar" element={<PromocionAddEditPage />} />
          <Route path="/app/admin/promocion/detalle/:id" element={<PromocionAddEditPage />} />
          <Route path="/app/admin/promocion/agregar-imagen/:id" element={<PromocionAddImagePage />} />

          {/*==================== Locales ====================*/}
          <Route path="/app/admin/locales" element={<LocalesPage />} />
          <Route path="/app/admin/local-add" element={<AddLocalPage />} />
          <Route path="/app/admin/local-editar/:id?" element={<AddLocalPage />} />
          <Route path="/app/admin/local-detalle/:id" element={<LocalDetallePage />} />

          <Route path="/app/admin/locales-categorias" element={<CategoriasPage />} />
          <Route path="/app/admin/locales-categorias-add" element={<AddCategoriaPage />} />
          <Route path="/app/admin/locales-categoria/:id" element={<AddCategoriaPage />} />

          {/*==================== Beneficios ====================*/}
          <Route path="/app/admin/beneficios" element={<BeneficiosPage />} />
          <Route path="/app/admin/beneficio-editar/:id?" element={<BeneficioAddDetailsPage />} />
          <Route path="/app/admin/beneficio-detalle/:id?" element={<BeneficioAddDetailsPage />} />


          <Route path="/app/admin/beneficios-locales/:id" element={<BeneficiosLocalesAdheridosPage />} />
          <Route path="/app/admin/beneficios-local/agregar/:id" element={<AdherirLocalPage />} />
          <Route path="/app/admin/beneficios-local/editar/beneficio/:id/local/:id" element={<AdherirLocalPage />} />
          <Route path="/app/admin/beneficios-agregar" element={<BeneficioAddDetailsPage />} />



          <Route path="/app/admin/beneficios-especiales" element={<BeneficiosEspecialesPage />} />

          {/*==================== Sorteos ====================*/}
          <Route path="/app/admin/sorteos" element={<SorteosAppPage />} />
          <Route path="/app/admin/sorteos-agregar" element={<AddSorteoPage />} />
          <Route path="/app/admin/sorteo-detalle/:id" element={<AddSorteoPage />} />

          <Route path="/app/admin/sorteo/buscar-cupon/:id" element={<BuscarCuponPage />} />
          <Route path="/app/admin/sorteo/factura-cupon/:id" element={<CuponDetallePage />} />
          <Route path="/app/admin/sorteo/sorteo-detalle/:id" element={<SorteoDetalle />} />
          <Route path="/app/admin/sorteo/sorteador-cupon/:id" element={<SorteadorPage />} />
          {/* <Route path="/app/admin/beneficios-especiales" element={<BeneficiosEspecialesPage />} /> */}


          {/*==================== Cupones ====================*/}
          <Route path="/app/admin/cupones" element={<CuponesPage />} />
          <Route path="/app/admin/cupon-detalle/:id" element={<DetalleCuponPage />} />
          <Route path="/app/admin/cupon-editar" element={<EditarCuponPage />} />
          {/* <Route path="/app/admin/beneficios-especiales" element={<BeneficiosEspecialesPage />} /> */}


          {/*==================== Banners ====================*/}
          <Route path="/app/admin/banners" element={<BannersAdminPage />} />
          <Route path="/app/admin/banners-agregar/:id?" element={<AddBannerPage />} />
          <Route path="/app/admin/banners-editar/:id?" element={<AddBannerPage />} />
          <Route path="/app/admin/banners-detalle/:id?" element={<AddBannerPage />} />

          {/*==================== Page ATC ====================*/}
          <Route path="/app/admin/atc/transaccion" element={<CrearTransaccionPage />} />
          <Route path="/app/admin/atc/itmes" element={<ItemsPage />} />
          <Route path="/app/admin/atc/itmes-agregar" element={<AddItemPage />} />
          <Route path="/app/admin/atc/itmes-detalle/:id" element={<AddItemPage />} />
          <Route path="/app/admin/atc/historial" element={<HistorialPage />} />


          {/*==================== Page Obsequios ====================*/}
          <Route path="/app/admin/obsequios/listar" element={<ObsequiosPage />} />
          <Route path="/app/admin/obsequios/obsequios-add/" element={<AddObsequiosPage />} />
          <Route path="/app/admin/obsequios/obsequios-detalle/:id" element={<AddObsequiosPage />} />
          <Route path="/app/admin/obsequios/informe-general" element={<InformeGeneralPage />} />

          <Route path="/app/admin/obsequios/filtrar" element={<FiltrarObsequiosPage />} />
          <Route path="/app/admin/obsequios/factura-detalle/:id" element={<FacturaObsequioDetallePage />} />

          <Route path="/app/admin/obsequios/listar-facturas" element={<ListarFacturasObsequiosPage />} />



          <Route path="/app/admin/obsequios/categorias" element={<ObsequiosCategoriasPage />} />
          <Route path="/app/admin/obsequios/categoria-add/" element={<AddObsequioCategoriaPage />} />
          <Route path="/app/admin/obsequios/categoria-detalle/:id" element={<AddObsequioCategoriaPage />} />

          <Route path="/app/admin/obsequios/subcategorias" element={<ObsequiosSubCategoriasPage />} />
          <Route path="/app/admin/obsequios/subcategoria-add/" element={<AddSubCategoriaPage />} />
          <Route path="/app/admin/obsequios/subcategoria-detalle/:id" element={<AddSubCategoriaPage />} />

          {/*==================== Page Encuestas ====================*/}
          <Route path="/app/admin/encuestas/listar" element={<EncuestasPage />} />
          <Route path="/app/admin/encuestas/agregar" element={<AddEncuestaPage />} />
          <Route path="/app/admin/encuestas/editar/:id" element={<AddEncuestaPage />} />

          {/*==================== Facturas ====================*/}
          <Route path="/app/admin/facturas" element={<FacturasPage />} />
          <Route path="/app/admin/facturas-detalle/:id" element={<FacturaDetallePage />} />
          <Route path="/app/admin/facturas-pendientes" element={<FacturasPendientesPage />} />
          <Route path="/app/admin/facturas-doble-check" element={<FacturasDobleCheckPage />} />
          {/* <Route path="/app/admin/cupon-detalle/:id" element={<DetalleCuponPage />} />
          <Route path="/app/admin/cupon-editar" element={<EditarCuponPage />} /> */}



          {/*==================== Notificaciones ====================*/}
          <Route path="/app/admin/notificaciones" element={<NotificacionesPage />} />
          <Route path="/app/admin/notificacion-add" element={<AddNotificacionPage />} />

        </Route>


        <Route element={<ProtectedRoutesLogin />}>
          {/* <Route path="/" element={<DashboardHome />} /> */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/app/login" element={<LoginPage />} />
        </Route>

        <Route path="*" element={<ErrorPage />} />
        {/* </Route> */}

      </Routes>
    </BrowserRouter>
  )
}

export default RutesScreen
